<template>
  <van-popup
    :value="value"
    round
    position="bottom"
    overlay
    @click-overlay="clickOverlay"
  >
    <h3 class="tag">
      购买以下任意会员<br>
      可解锁本课程
    </h3>
    <div class="vips-wrapper">
      <template v-for="(vip, index) in vipsNeeded">
        <div
          :key="index"
          class="vip-card"
          @click.stop="clickHandler(vip)"
        >
          <p v-if="!vip.expired" class="end-date">
            有效期至 {{ vip.expiredAt | dateFormat }}
          </p>
          <p class="name">{{ vip.name }}</p>
          <div class="related-wrapper">
            <div v-if="organization.moduleCourses.enable" class="related">
              {{ vip.coursesCount }}
              <p class="label">{{ organization.moduleCourses.title }}</p>
            </div>
            <div v-if="organization.moduleNews.enable" class="related">
              {{ vip.videosCount }}
              <p class="label">{{ organization.moduleNews.title }}</p>
            </div>
          </div>
          <p class="worth">¥ <span v-money="vip.cashNeeded" class="money" /></p>
        </div>
      </template>
    </div>
  </van-popup>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'VipListPopup',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false
    },
    vipsNeeded: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    ...mapGetters(['organization'])
  },
  methods: {
    ...mapActions(['updateVip']),
    clickOverlay () {
      this.$emit('change', false)
      this.$emit('clickOverlay')
    },
    clickHandler (vip) {
      this.$emit('change', false)
      this.updateVip(vip)
      console.log(vip)
      this.$router.push({
        name: 'vip-id',
        params: {
          id: vip.id
        },
        query: {
          'return_to_url': this.$route.fullPath
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tag {
  @include sc($font-size-lg, $color-text-heavy);
  margin: 20px 0;
  line-height: 28px;
  font-weight: 500;
  text-align: center;
}
.vips-wrapper {
  @include wh(100%, 500px);
  .vip-card {
    @include wh(100%, 175px);
    @include bg-image-png('/vip/vip-card');
    @include flex;
    justify-content: space-between;
    padding: 20px 43px;
    margin: 0 auto 25px;
    background-size: 343px 175px;
    background-position: center;
    background-repeat: no-repeat;
    color: #BF8736;
    .end-date {
      @include sc($font-size-md, inherit);
    }
    .name {
      @include sc(27px, inherit);
      @include lw(32px, 600);
      @include ellipsis(1, 32px);
      @include wh(100%, 32px);
    }
    .related-wrapper {
      @include sc($font-size-md, inherit);
      @include lw(16px, 600);
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      text-align: center;
      .related {
        border: 1px solid transparent;
        + .related {
          border-left-color: rgba(191, 134, 54, 0.3);
        }
        .label {
          font-weight: 400;
          margin-top: 8px;
        }
      }
    }
    .worth {
      @include sc($font-size-base, inherit);
      .money {
        @include sc($font-size-lg, inherit);
        @include lw(16px, 600);
      }
    }
  }
}
</style>
